import { createTheme } from '@mui/material/styles';

import InterRegular from 'assets/fonts/Inter-Regular.woff2';

import { RxButton } from './RxButton';
import { RxFormLabel } from './RxFormLabel';
import { RxTableCell } from './RxTableCell';
import { RxTooltip } from './RxTooltip';

declare module '@mui/material/styles' {
  type StatusColors = { bg: string; text: string };
  interface Palette {
    status: {
      yellow: StatusColors;
      green: StatusColors;
      blue: StatusColors;
    };
  }
  interface Theme {
    body: {
      background: string;
    };
    fontSizes: {
      xs: string;
      sm: string;
      md: string;
      lg: string;
      xl: string;
    };
  }
  interface ThemeOptions {
    body?: {
      background?: string;
    };
    fontSizes?: {
      xs?: string;
      sm?: string;
      md?: string;
      lg?: string;
      xl?: string;
    };
  }
}

const RxDefineAdminTheme = {
  name: 'Green',
  palette: {
    primary: { main: '#6918D0', contrastText: '#FFF' },
    secondary: { main: '#1b202f', contrastText: '#FFF' },
    success: { main: '#5FA560', contrastText: '#FFF' },
    warning: { main: '#E9921F', contrastText: '#FFF' },
    info: { main: '#333333', contrastText: '#FFF' },
    error: { main: '#FF5E5E', contrastText: '#FFF' },
    disabled: { main: 'rgba(0, 0, 0, 0.5)', contrastText: '#FFF' },
    text: { primary: '#333', secondary: '#666' },
    status: {
      yellow: { bg: '#FDF5B3', text: '#C77E1E' },
      green: { bg: '#ECFDEC', text: '#5FA560' },
      blue: { bg: '#EBF9FD', text: '#2DC6E8' },
    },
  },
};

const theme = createTheme({
  palette: { ...RxDefineAdminTheme.palette },
  spacing: 4,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: '"InterRegular", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    h1: { fontSize: '2.5rem', fontWeight: 600 },
    h2: { fontSize: '2rem', fontWeight: 600 },
    h3: { fontSize: '1.75rem', fontWeight: 600 },
    h4: { fontSize: '1.5rem', fontWeight: 600 },
    h5: { fontSize: '1.25rem', fontWeight: 600 },
    h6: { fontSize: '1rem', fontWeight: 600 },
    body1: { fontSize: 14 },
    body2: { fontSize: 13 },
    button: { textTransform: 'none' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'InterRegular';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: url(${InterRegular}) format('woff2');
        }

        html,
        body,
        #root {
          height: 100%;
        }

        body {
          font-family: 'InterRegular', sans-serif;
          background: #F5F5F5;
        }

        .scrollbar-container {
          position: relative;
          height: 100%;
        }

        .ps {
          overflow: hidden;
          touch-action: auto;
        }

        .ps__rail-x {
          display: none;
        }
      `,
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          '& td': {
            fontSize: 16,
          },
        },
      },
    },
    MuiTooltip: RxTooltip,
    MuiButton: RxButton,
    MuiFormLabel: RxFormLabel,
    MuiTableCell: RxTableCell,
  },
  body: {
    background: '#ffffff',
  },
});

export default theme;
